export const loader = (target, Class) => {
	const query = document.querySelectorAll(target);
	Array.from(query).forEach((element) => {
		new Class(element);
	});
}
